// @ts-nocheck
import { Plugin } from '/data1/jenkins/workspace/aplus_tiger_202111invite8a39a4a0-63c6-401a-b0da-8b1d91baec64_tiger-platform_huya-promo_202111invite_19893_nodejs_prod/node_modules/.pnpm/@umijs+runtime@3.5.41_react@16.14.0/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu',],
});

export { plugin };
